import BaseEnum from './BaseEnum';

class ActiveCustomers extends BaseEnum {
  fieldsMap = {
    branch: 'Branch',
    customer: 'Customer',
    email: 'Email',
    status: 'Status',
  };
}

export default ActiveCustomers.make();